import { render, staticRenderFns } from "./check-login.vue?vue&type=template&id=407bca7f&scoped=true&"
import script from "./check-login.vue?vue&type=script&lang=js&"
export * from "./check-login.vue?vue&type=script&lang=js&"
import style0 from "./check-login.vue?vue&type=style&index=0&id=407bca7f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407bca7f",
  null
  
)

export default component.exports